/* eslint-disable indent */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Logger } from '@vue-storefront/core/lib/logger'
import { once } from '../helpers/once'
import config from 'config'

once('__VUE_EXTEND_I18N__', () => {
  Vue.use(VueI18n)
})

const defaultLocale = config.i18n.defaultLocale || 'en-US'
const loadedLanguages = [defaultLocale]
const i18n = new VueI18n({
  locale: defaultLocale, // set locale
  fallbackLocale: defaultLocale,
  messages: config.i18n.bundleAllStoreviewLanguages
    ? require('./resource/i18n/multistoreLanguages.json')
    : {
      [defaultLocale]: require(`./resource/i18n/${defaultLocale}.json`)
    }
})

function setI18nLanguage (lang: string): string {
  i18n.locale = lang
  return lang
}

export async function loadLanguageAsync (lang: string): Promise<string> {
  if (!config.i18n.bundleAllStoreviewLanguages) {
    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        try {
          const msgs = await import(/* webpackChunkName: "lang-[request]" */ `./resource/i18n/${lang}.json`)
          const localeMessages = (msgs as { default?: Record<string, unknown> }).default ?? msgs
          i18n.setLocaleMessage(lang, localeMessages as Record<string, string>)
          loadedLanguages.push(lang)
          return setI18nLanguage(lang)
        } catch (e) { // eslint-disable-line handle-callback-err
          Logger.debug('Unable to load translation')()
          return ''
        }
      }
      return setI18nLanguage(lang)
    }
  } else {
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  }
  return lang
}

export default i18n
